import styled from 'styled-components';

export const HEADER_HEIGHT = 60;
export const FOOTER_HEIGHT = 68;
export const HEADER_AND_FOOTER_HEIGHT = HEADER_HEIGHT + FOOTER_HEIGHT;

export const Wrapper = styled.div<{ isGhostMode?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  background-color: ${({ theme }): string => theme.admanColors!.gray.light.fg[6]};
  min-height: ${({ isGhostMode }): string => {
    const ghostModeHeight = isGhostMode ? 36 : 0;
    return `calc(100vh - ${HEADER_AND_FOOTER_HEIGHT + ghostModeHeight}px) `;
  }};
`;
